export function storeLocalData(key, data) {
  try {
    if (!data) throw new Error('Undefined data');

    let localData;

    if (typeof data === 'object') {
      localData = JSON.stringify(data);
    } else if (typeof data === 'string') {
      localData = data;
    } else {
      throw new Error('Data no valida');
    }

    const base64LocalData = window.btoa(unescape(encodeURI(localData)));

    localStorage.setItem(key, base64LocalData);
  } catch (error) {
    throw new Error(error.message);
  }
}

export function getLocalData(key) {
  try {
    const base64LocalData = localStorage.getItem(key);

    if (base64LocalData) {
      const localData = decodeURIComponent(escape(window.atob(base64LocalData)));

      return JSON.parse(localData);
    } else {
      return null;
    }
  } catch (error) {
    throw new Error(error.message);
  }
}
